import { get } from 'lodash';
import { createSelector } from 'reselect';
import { ViewTypes } from './reducers';
import SCOPE from './types';

const selector = state => get(state, SCOPE);

export const policiesSelector = createSelector(selector, state => state.policies);

export const isScheduleViewSelector = createSelector(selector,
  store => store.activeView === ViewTypes.schedules
);

export default selector;
